import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Calendar } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide08Expansion({
  index
}: SlideProps) {
  return <InteriorSlide data-id="element-159" data-mp="10xo19gpj0puf">
      <SlideHeader eyebrow="Asset Lifespan Recommendation" data-id="element-160" data-mp="15u63a8th2a32">
        The teaser needs freshness sooner than the trailer
      </SlideHeader>

      <div className="flex-1 flex flex-col justify-center max-w-5xl mx-auto w-full gap-8" data-id="element-161" data-mp="1aspou845ljuw">
        {/* Teaser Card */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col md:flex-row items-center gap-8" data-id="element-162" data-mp="1fqr9uyl53t90">
          <div className="flex-1" data-id="element-163" data-mp="1yjd0n4h6wtmq">
            <div className="flex items-center gap-3 mb-4" data-id="element-164" data-mp="1lvbmgw9l0w86">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)]" data-id="element-165" data-mp="1lwmtd4ybqk3i">
                <Clock className="h-5 w-5" data-id="element-166" data-mp="1cunb69bkp9yz" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-167" data-mp="1cv6sbntefuby">
                Master Teaser
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-168" data-mp="17xwsrfcaq2ae">
              Can support up to 6 campaign adaptations. After 6 campaigns, it
              should receive a more substantial update than a simple facelift.
            </p>
            <div className="inline-flex items-center gap-2 bg-[var(--surface)] px-4 py-2 rounded-lg text-sm font-bold text-[var(--brand)]" data-id="element-169" data-mp="1vshh2ehen5d5">
              Update cost: €1,250 every 6 months
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-170" data-mp="2obd9l69r8xi1">
            <div className="h-4 bg-black/5 rounded-full overflow-hidden" data-id="element-171" data-mp="2jjdh1yw0l6vh">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '50%'
            }} transition={{
              delay: 0.6,
              duration: 1
            }} className="h-full bg-[var(--brand)] rounded-full" data-id="element-172" data-mp="2jh0rp0nxfu8e" />
            </div>
            <div className="flex justify-between mt-2 text-xs font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-173" data-mp="2xmsyq3zxi4mi">
              <span data-id="element-174" data-mp="2jr7a3xxlxmum">Month 1</span>
              <span data-id="element-175" data-mp="2oo7gyb2a6tms">Month 6</span>
              <span data-id="element-176" data-mp="2opijy8nwjxcu">Month 12</span>
            </div>
          </div>
        </motion.div>

        {/* Trailer Card */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 flex flex-col md:flex-row items-center gap-8" data-id="element-177" data-mp="2aq96vhuztjd3">
          <div className="flex-1" data-id="element-178" data-mp="1xecpn8g8faam">
            <div className="flex items-center gap-3 mb-4" data-id="element-179" data-mp="1tfdntwpsrtne">
              <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--fg)]" data-id="element-180" data-mp="1tcr4z0xghrpv">
                <Calendar className="h-5 w-5" data-id="element-181" data-mp="22figf0qc0nhi" />
              </div>
              <h3 className="text-2xl font-bold text-[var(--fg)]" data-id="element-182" data-mp="22e7gxd3x61w7">
                Master Trailer / Microsite
              </h3>
            </div>
            <p className="text-[var(--muted)] leading-relaxed mb-6" data-id="element-183" data-mp="2c5v0ysy5cgnn">
              Can support up to 12 months of campaign activity. After 12 months,
              it should receive a larger overhaul preparing the next annual
              cycle.
            </p>
            <div className="inline-flex items-center gap-2 bg-[var(--surface)] px-4 py-2 rounded-lg text-sm font-bold text-[var(--fg)]" data-id="element-184" data-mp="2l3x7fo0ng1ib">
              Update cost: €2,250 every 12 months
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-185" data-mp="t6nmf6xl2g2n">
            <div className="h-4 bg-black/5 rounded-full overflow-hidden" data-id="element-186" data-mp="t5vtk3vdewg2">
              <motion.div initial={{
              width: 0
            }} animate={{
              width: '100%'
            }} transition={{
              delay: 0.8,
              duration: 1.5
            }} className="h-full bg-[var(--fg)] rounded-full" data-id="element-187" data-mp="x7hdg96boazr" />
            </div>
            <div className="flex justify-between mt-2 text-xs font-bold text-[var(--muted)] uppercase tracking-wider" data-id="element-188" data-mp="ehhpjpm7x1xx">
              <span data-id="element-189" data-mp="jft2483wdqju">Month 1</span>
              <span data-id="element-190" data-mp="jfjbqjexxhdm">Month 6</span>
              <span data-id="element-191" data-mp="o7aqzxsnc0og">Month 12</span>
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}